<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="contract-number-prefixes">Префиксы номеров контрактов</label>
    <input
      type="text"
      class="form-control"
      id="contract-number-prefixes"
      placeholder='Введите префиксы, пр.: "1718,1719,1720"'
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'contract-number-prefixes-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContractNumberPrefixes.vue?7ebb9abc